module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/btn-hover-styles/btn-hover-styles.component.scss
// module id = ./src/app/features/buttons/btn-hover-styles/btn-hover-styles.component.scss
// module chunks = main